import classnames from 'classnames'
import React, { forwardRef } from 'react'
import IconTooltip from '../IconTooltip'

interface Props {
  name: string
  label?: string
  options: RadioOption[]
  infoTip?: string | React.ReactNode
  errorMessage?: string
  defaultValue?: string
}

type RadioOption =
  | string
  | number
  | {
      label?: string
      value: string | number
    }

const RadioButtons = forwardRef<HTMLInputElement, Props & React.HTMLProps<HTMLInputElement>>(
  ({ label, name, options, infoTip, errorMessage, defaultValue, ...rest }, ref) => {
    const makeOption = (option: RadioOption, index: number) => {
      const value = typeof option === 'object' ? option.value : option
      const label = typeof option === 'object' ? option.label : option

      return (
        <div key={index} className='radio-buttons-input'>
          <input
            id={`${name}-${index}`}
            name={name}
            ref={ref}
            type='radio'
            value={value}
            defaultChecked={defaultValue == value}
            {...rest}
          />
          <label htmlFor={`${name}-${index}`}>{label}</label>
        </div>
      )
    }

    return (
      <fieldset
        className={classnames('radio-buttons', { 'radio-buttons-has-error': !!errorMessage })}
      >
        {label && (
          <div className='radio-buttons-label'>
            <label>{label}</label>{' '}
            {infoTip && (
              <IconTooltip
                place='top'
                iconClassName='radio-buttons-infotip fal fa-info-circle'
                popupContent={infoTip}
              />
            )}
          </div>
        )}
        <div className='radio-buttons-inputs'>{options.map(makeOption)}</div>
        {errorMessage && <div className='radio-buttons-error'>{errorMessage}</div>}
      </fieldset>
    )
  }
)

RadioButtons.displayName = 'RadioButtons'
export default RadioButtons
